<!-- Sticky Navigation: UChicago-inspired — minimal, two-tier, clear CTAs -->
<header class="sticky top-0 z-50 w-full bg-white border-b border-[#1a1a4b]/8">
  <!-- Top utility bar: navy background, white text -->
  <div class="bg-[#1a1a4b]">
    <div class="mx-auto flex max-w-7xl justify-end gap-6 px-4 py-2 text-sm sm:px-6 lg:px-8">
      <a href="#fee-calculator" class="text-white hover:underline">Fee estimate</a>
      <a href="#admissions" class="text-white hover:underline">How to apply</a>
      <a href="#contact" class="text-white hover:underline">Contact Us</a>
      <a href="#features" class="text-white hover:underline">Visit Our Campus</a>
    </div>
  </div>

  <!-- Main nav: tablet/mobile [hamburger | logo] until lg; desktop left links | center logo | right links -->
  <nav class="relative z-0 mx-auto grid max-w-7xl grid-cols-[auto_1fr] items-center gap-4 px-4 py-3 sm:px-6 lg:grid-cols-[1fr_auto_1fr] lg:px-8">
    <!-- Left: nav links (hidden until lg / desktop) -->
    <div class="hidden items-center justify-end gap-6 lg:flex">
      <a routerLink="/" (click)="scrollToHero($event)" class="text-[#1a1a4b] text-[15px] hover:underline">Home</a>
      <a href="#about" class="text-[#1a1a4b] text-[15px] hover:underline">About</a>
      <a href="#why-us" class="whitespace-nowrap text-[#1a1a4b] text-[15px] hover:underline">Why Us</a>
      <a href="#curriculum" class="text-[#1a1a4b] text-[15px] hover:underline">Curriculum</a>
      <a href="#features" class="text-[#1a1a4b] text-[15px] hover:underline">Facilities</a>
      <a href="#school-life" class="whitespace-nowrap text-[#1a1a4b] text-[15px] hover:underline">School life</a>
      <a routerLink="/gallery" class="text-[#1a1a4b] text-[15px] hover:underline">Gallery</a>
    </div>

    <!-- Center: logo + school name (tablet/mobile: absolutely centered; desktop: in-flow) -->
    <a
      routerLink="/"
      (click)="scrollToHero($event)"
      class="order-2 flex items-center justify-center gap-2 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 lg:static lg:order-none lg:left-auto lg:top-auto lg:translate-x-0 lg:translate-y-0 lg:gap-3"
    >
      <img
        src="logo.png"
        alt="D.S. Genius Public School — English medium CBSE campus in Debra, Paschim Medinipur"
        class="h-10 w-auto sm:h-11"
        width="160"
        height="44"
        loading="lazy"
      />
      <span class="font-serif whitespace-nowrap text-sm font-semibold tracking-tight text-[#1a1a4b] sm:text-base lg:text-lg">D.S. Genius Public School</span>
    </a>

    <!-- Right: nav links + phone + Portal (tablet/mobile: hamburger only; desktop: full links) -->
    <div class="order-first flex items-center justify-end gap-4 lg:order-none lg:gap-6">
      <div class="hidden items-center gap-6 lg:flex">
        <a href="#fee-calculator" class="text-[#1a1a4b] text-[15px] hover:underline">Fee estimate</a>
      <a href="#admissions" class="text-[#1a1a4b] text-[15px] hover:underline">Admissions</a>
        <a href="#contact" class="text-[#1a1a4b] text-[15px] hover:underline">Contact</a>
        <a href="tel:+916296600402" class="text-[#1a1a4b] text-[15px] hover:underline">+91 62966 00402</a>
        <div class="flex items-center gap-3 border-l border-[#1a1a4b]/15 pl-5">
          <a
            href="#parent-portal"
            class="text-[15px] font-bold tracking-tight text-[#1a1a4b] underline-offset-4 hover:underline"
            >Parent portal</a
          >
          <span class="text-[#1a1a4b]/25 select-none" aria-hidden="true">|</span>
          <a
            [href]="adminPortalUrl"
            class="text-[15px] font-bold tracking-tight text-[#1a1a4b] underline-offset-4 hover:underline"
            (click)="openAdminPortal($event)"
            >Admin portal</a
          >
        </div>
      </div>
      <button
        type="button"
        class="inline-flex items-center justify-center rounded p-2 text-[#1a1a4b] hover:bg-[#1a1a4b]/5 lg:hidden"
        (click)="mobileMenuOpen = !mobileMenuOpen"
        [attr.aria-expanded]="mobileMenuOpen"
        aria-label="Toggle menu"
      >
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          @if (mobileMenuOpen) {
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          } @else {
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          }
        </svg>
      </button>
    </div>
  </nav>

  @if (mobileMenuOpen) {
    <div class="relative z-20 border-t border-[#1a1a4b]/8 bg-white px-4 py-4 lg:hidden">
      <div class="flex flex-col items-stretch text-left text-[15px]">
        <a routerLink="/" (click)="scrollToHero($event); mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">Home</a>
        <a href="#about" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">About</a>
        <a href="#why-us" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center whitespace-nowrap py-2.5 text-[#1a1a4b] hover:underline">Why Us</a>
        <a href="#curriculum" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">Curriculum</a>
        <a href="#features" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">Facilities</a>
        <a href="#school-life" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center whitespace-nowrap py-2.5 text-[#1a1a4b] hover:underline">School life</a>
        <a routerLink="/gallery" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">Gallery</a>
        <a href="#fee-calculator" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">Fee estimate</a>
        <a href="#admissions" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">Admissions</a>
        <a href="#contact" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">Contact</a>
        <a href="tel:+916296600402" (click)="mobileMenuOpen = false" class="min-h-[44px] flex items-center py-2.5 text-[#1a1a4b] hover:underline">+91 62966 00402</a>
        <span class="mt-3 mb-1 text-xs font-semibold uppercase tracking-wider text-[#1a1a4b]/60">Portal login</span>
        <a
          href="#parent-portal"
          (click)="mobileMenuOpen = false"
          class="min-h-[44px] flex items-center py-2 text-[15px] font-bold text-[#1a1a4b] hover:underline"
          >Parent portal</a
        >
        <a
          [href]="adminPortalUrl"
          (click)="openAdminPortal($event)"
          class="min-h-[44px] flex items-center py-2 text-[15px] font-bold text-[#1a1a4b] hover:underline"
          >Admin portal</a
        >
      </div>
    </div>
  }
</header>

<router-outlet />
